import { PortalEventContextType, type PortalMyBidDto } from "../../../autogen/bff-api";
import type { PortalEventUrls } from "../../../common/sourcing-events/portal/usePortalEventUrls";

export const v1BidLinkToCurrent = (portalUrls: PortalEventUrls, bid: PortalMyBidDto): string => {
  if (bid.event.contextType === PortalEventContextType.Private) {
    return portalUrls.privateBid.edit.go(bid.eventId, bid.bidId);
  }
  const { pathname, search } = portalUrls.bid.edit.go(bid.eventId, bid.bidId).intro;
  return `${pathname}?${search}`;
};
